export default __webpack_public_path__ + "static/media/gif.fa11ec60.gif";